export enum NotificationEnum {
  error = "error",
  success = "success",
  warning = "warning",
  info = "info",
}
